import { defaultConfig, defineRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const skeletonRecipe = defineRecipe(
    merge(defaultConfig?.theme?.recipes?.skeleton, {
        variants: {
            loading: {
                true: {
                    borderColor: 'transparent',
                },
                false: {
                    background: 'var(--bg-currentcolor)',
                    animation: 'none',
                },
            },
            variant: {
                shine: {
                    '--start-color': 'white',
                    '--end-color': 'colors.bg.emphasized',
                },
            },
        },
        defaultVariants: {
            variant: 'shine',
        },
    }),
);
